import React, { useState } from 'react';
import { Button, Form, Row, Col } from 'react-bootstrap';
import NotificationService from './notificationService';

export function NotificationForm(prop) {
    const [notificationSer] = useState(new NotificationService());
    const [email, setEmail] = useState(null);
    const [emailVaild, setEmailVaild] = useState(true);
    const [preference, setPreference] = useState('NO_EMAILS');

    const emailNotvalid = 'Please enter a valid email address.';
    const emailExists = 'Enter email address already exists';
    const [validation, setValidation] = useState(emailNotvalid);
 
    const { toggleModel, setNotificationListData,  customerId , data} = prop;



    
    const saveCompanyPreferences = async (event) => {
        event.preventDefault();
        let emailExist = false;
        data.forEach(da => {
            if(da.email === email){
                emailExist = true;
            }
        });

        if(emailExist){
            setEmailVaild(false);
            setValidation(emailExists);
        }else{
            await notificationSer.saveCompanyPreferences({
                companyId: customerId,
                email: email,
                preference: preference
            });
            setNotificationListData(await notificationSer.getAllCompanyPreferences(customerId));
            toggleModel();
        }
    };
    
    const handleChange = (event) => {
        event.preventDefault();
        const { name, value } = event.target;
        if (name === 'email') {
            if(validEmailRegex.test(value)){
                setEmailVaild(true);
                setEmail(value);
            }else{
                setEmail(value);
                setEmailVaild(false);
                setValidation(emailNotvalid);
            }
        }
    };    

    const handleDropdownChange = (event) => {
        const value = event.target.value;
        setPreference(value);
    };

    const validEmailRegex = RegExp(
        "^(([^<>()[]\\.,;:s@]+(.[^<>()[]\\.,;:s@]+)*)|(.+))@(([[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}])|(([a-zA-Z-0-9]+.)+[a-zA-Z]{2,}))$"
      );
 

    return (
        <div>
            <Form  onSubmit={saveCompanyPreferences} noValidate>
                <Row className="mt-3">
                    <Col md={12}>
                        <Form.Group className="mb-2">
                            <Form.Label>Email Address</Form.Label>
                            <Form.Control
                                type="text"
                                id="email"
                                name="email"
                                placeholder="Email Adress"
                                autoComplete="none"
                                className="email"
                                required
                                onChange={handleChange}
                                value={email}
                                pattern="^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$"
                            />
                            { !emailVaild && <p className='error'>
                            {validation}
                            </p>
                            }
                        </Form.Group>
                    </Col>
                </Row>
                <Row className="mt-3">
                    <Col md={12}>
                        <Form.Group className="mb-2">
                            <Form.Label>Notification Preference</Form.Label>
                            <Form.Control  as="select"   onChange={handleDropdownChange} >
                                <option value="NO_EMAILS">None</option>
                                <option value='ALL_JOBS'>All Jobs</option>
                                <option value='ERRORS_ONLY'>Errors Only</option>
                            </Form.Control>
                        </Form.Group>
                    </Col>
                </Row>
                
                <Row className="mt-3">
                    <Col md={4}>
                        <Button
                            type="submit"
                            className="submit-btn"
                            variant="primary"
                            size="lg"
                            id="save-btn"
                            block
                            disabled={!(email && preference)}
                        >
                            Save
                        </Button>
                    </Col>
                    <Col md={4}>
                        <Button
                            type="submit"
                            className="submit-btn"
                            variant="primary"
                            size="lg"
                            id="cancel-btn"
                            onClick={toggleModel}
                        >
                            Cancel
                        </Button>
                    </Col>
                </Row>
            </Form>
        </div>
    );
}

export default NotificationForm;
